import React, { useCallback, useEffect, useState } from "react";
import { Button, SaveButton, SimpleForm, useNotify, useRefresh } from "react-admin";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";
import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RoomInput from "server/components/Fields/RoomInput";
import CustomDateTimeInput from "server/components/Fields/CustomDateTimeInput";
import { useNotifyError } from "utils/useNotifyError";

const StateExamSlotEditForm = ({ record, setIsSlotEditing }) => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();

  const [internshipSessionFromDate, setInternshipSessionFromDate] = useState(null);
  const [internshipSessionToDate, setInternshipSessionToDate] = useState(null);

  const internshipSessionId = record?.internshipSessionId;

  const fetchInternshipSessionsDate = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        graduationRequests.getInternshipSession(internshipSessionId),
        null,
        "GET",
      );
      setInternshipSessionFromDate(data?.startDate);
      setInternshipSessionToDate(data?.endDate);
    } catch (err) {
      console.error(err);
    }
  }, [internshipSessionId]);

  useEffect(() => {
    if (!internshipSessionId) return;
    fetchInternshipSessionsDate();
  }, [internshipSessionId, fetchInternshipSessionsDate]);

  const handleSubmit = async data => {
    const payload = { examTimestamp: data.examTimestamp, roomId: data.roomId };
    try {
      await dataProvider.customRequest(graduationRequests.updateStateExamSlot(record?.id), payload, "PUT");
      refresh();
      notify("Записът е редактиран", { type: "success" });
      setIsSlotEditing(false);
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <Grid sx={{ width: "100%" }}>
      <SimpleForm
        toolbar={false}
        sx={{ pt: 0, pl: 0 }}
        onSubmit={handleSubmit}
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <RoomInput
              label="Зала"
              source="roomId"
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <CustomDateTimeInput
              source="examTimestamp"
              label="Дата и час на изпит"
              minDate={internshipSessionFromDate}
              maxDate={internshipSessionToDate}
            />
          </Grid>
        </Grid>
        <Grid sx={{ display: "flex", gap: 3, mt: 3 }}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            size="small"
            label="Откажи"
            onClick={() => setIsSlotEditing(false)}
          />
          <SaveButton
            label="Запази"
            size="small"
          />
          <ConflictErrorDialog />
        </Grid>
      </SimpleForm>
    </Grid>
  );
};

export default StateExamSlotEditForm;
